function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = React.createElement("path", {
  d: "M15.1667 2.66667C15.1667 4.13943 13.9728 5.33334 12.5 5.33334C11.0272 5.33334 9.83334 4.13943 9.83334 2.66667C9.83334 1.19391 11.0272 0 12.5 0C13.9728 0 15.1667 1.19391 15.1667 2.66667Z",
  fill: "#004152"
});

var _ref3 = React.createElement("path", {
  d: "M15.1667 12C15.1667 13.4728 13.9728 14.6667 12.5 14.6667C11.0272 14.6667 9.83334 13.4728 9.83334 12C9.83334 10.5273 11.0272 9.33334 12.5 9.33334C13.9728 9.33334 15.1667 10.5273 15.1667 12Z",
  fill: "#004152"
});

var _ref4 = React.createElement("path", {
  d: "M12.5 24C13.9728 24 15.1667 22.8061 15.1667 21.3333C15.1667 19.8606 13.9728 18.6667 12.5 18.6667C11.0272 18.6667 9.83334 19.8606 9.83334 21.3333C9.83334 22.8061 11.0272 24 12.5 24Z",
  fill: "#004152"
});

var SvgThreeDotsVertical = function SvgThreeDotsVertical(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgThreeDotsVertical, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/three-dots-vertical.6543d461.svg";
export { ForwardRef as ReactComponent };